<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-1" id="untitled-1"></div>
<div class="calibre1" id="untitled-11">
<div class="calibre1"></div>
<div class="calibre1">
<p class="normal-222-0-override"><span class="no-style-override1"><br/></span></p>
<p class="normal-222-0-override"><span class="no-style-override1"><br/></span></p>
<p class="normal-222-0-override"><span class="no-style-override1">For Barb.</span></p>
<p class="normal-222-0-override"><span class="no-style-override1">All my love,</span></p>
<p class="normal-222-0-override"><span class="no-style-override1">all my life.</span></p>
<p class="calibre2" id="calibre_pb_4"></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0000_split_002.vue?4017f898